var exports = {
  "kL": "AvatarWithPresence.module__container___MmxYQ2",
  "_V": "AvatarWithPresence.module__containerSpeaking___MmxYQ2",
  "V5": "AvatarWithPresence.module__voiceIndicatorIcon___MmxYQ2",
};

module.exports = exports;
